interface CallbackDefinition {
  controller: string
  function: string
}

interface RenderReactComponentOptions {
  container: HTMLElement
  componentName: string
  props?: Record<string, any>
  callbacks?: Record<string, CallbackDefinition>
}

export function renderReactComponent({
  container,
  componentName,
  props = {},
  callbacks = {},
}: RenderReactComponentOptions): HTMLElement {
  container.innerHTML = ''

  const reactDiv = document.createElement('div')
  reactDiv.setAttribute('data-react-component', componentName)
  reactDiv.setAttribute('data-react-props', JSON.stringify(props))

  if (Object.keys(callbacks).length > 0) {
    reactDiv.setAttribute('data-react-callbacks', JSON.stringify(callbacks))
  }

  container.appendChild(reactDiv)

  document.dispatchEvent(new Event('turbo:load'))

  return reactDiv
}

export function unmountReactComponent(container: HTMLElement): void {
  container.innerHTML = ''
}

export function hasReactComponent(container: HTMLElement): boolean {
  return container.children.length > 0
}
